import { Account, Product } from '@features/accounts/types';
import { redirect } from '@tanstack/react-router';

export type TransferGuardProps = {
  products?: Product[];
  accounts?: Account[];
  fundsTransferable?: boolean;
  hasOptimized?: boolean;
  href: string;
};

export const transferGuard = ({
  products,
  accounts,
  fundsTransferable,
  hasOptimized,
  href,
}: TransferGuardProps) => {
  const hasPendingProducts = products?.some((p) => p.pending);

  if (hasPendingProducts && accounts?.length === 0) {
    //eslint-disable-next-line
    throw redirect({
      to: '/transfers/accounts-pending',
    });
  }

  if (!hasPendingProducts && accounts?.length === 0) {
    //eslint-disable-next-line
    throw redirect({
      to: `/transfers/add-accounts`,
    });
  }

  if (!fundsTransferable && hasOptimized) {
    //eslint-disable-next-line
    throw redirect({
      to: `/transfers/in-progress`,
    });
  }

  //eslint-disable-next-line
  throw redirect({
    href,
  });
};
